const destroySession = () => {
    localStorage.removeItem('sessionData');
    localStorage.removeItem('role');
    return true;
};

export default destroySession;
